// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VDTD","type":"styles_type__392Is","choices":"styles_choices__1bCq-"};